import React from "react";
import TeamPositions from "../positions/TeamPositions";
import { TeamsWithColours } from "../RoundResultsPage";
import ResultsLineChart from "./ResultsLineChart";
import { useResultsContext } from "../context/context";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import VerticalGroup from "../../../atoms/verticalgroup/VerticalGroup";

interface Props {
  data: object[];
  teams: TeamsWithColours[];
  formatter?: (val: number) => string | number;
  toolTipFormatter?: (val: number) => string | number;
  yAxisFormatter?: (val: number) => string | number;
  maxYAxisvalue: number;
  minYAxisvalue: number;
  numberOfTicks: number;
  teamPositions?: ModelAPI.Reporting.TeamPosition[];
  tooltipOrdering?: "highest" | "lowest";
}

const ResultsTeamLineChart: React.FC<Props> = ({
  data,
  teams,
  formatter,
  yAxisFormatter,
  maxYAxisvalue,
  minYAxisvalue,
  numberOfTicks,
  teamPositions,
  tooltipOrdering,
  toolTipFormatter,
}) => {
  const lines = teams.map((t) => ({
    name: t.teamName,
    key: `team${t.teamId}`,
    colour: t.colour,
  }));

  const context = useResultsContext();
  return (
    <VerticalGroup wide full center style={{ marginRight: "45px" }}>
      <ResultsLineChart
        data={data}
        formatter={formatter}
        yAxisFormatter={yAxisFormatter}
        maxYAxisvalue={maxYAxisvalue}
        minYAxisvalue={minYAxisvalue}
        numberOfTicks={numberOfTicks}
        lines={lines}
        tooltipOrdering={tooltipOrdering}
        toolTipFormatter={toolTipFormatter}
      />
      {!context.hideTeamPositions &&
        teamPositions &&
        teamPositions.length > 0 && (
          <InlineGroup>
            <TeamPositions teams={teams} teamPositions={teamPositions} />
          </InlineGroup>
        )}
    </VerticalGroup>
  );
};

export default ResultsTeamLineChart;
